import React from 'react';
import PropTypes from 'prop-types';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import {Box, Heading, Media, Paper, Tag, Text} from '@tenancy.nz/ui';
import IconLabel from './IconLabel';
import PropertyAttributes from './PropertyAttributes';
import {StyledPropertyItemImgWrapper} from './PropertyItem.styled';
import placeholderImage from '../assets/placeholder-property.jpeg';

function PropertyCard({
  onView = null,
  photo = '',
  addressPart1 = '',
  addressPart2 = '',
  rentAmount = '',
  dateAvailable = '',
  bedrooms = null,
  bathrooms = null,
  parkingSpaces = null,
}) {
  return (
    <Box
      onClick={onView}
      sx={{
        transition: 'all 0.25s ease-out',
        cursor: onView ? 'pointer' : 'default',
        '&:hover': {transform: 'translateY(-6px)'},
      }}>
      <Paper overflow={false}>
        <StyledPropertyItemImgWrapper>
          <Media
            src={photo || placeholderImage}
            title={addressPart1}
            as="img"
          />
        </StyledPropertyItemImgWrapper>
        <Box padding={4} position="relative" width="100%">
          <Heading as="h4">{addressPart1}</Heading>
          <Text sx={{fontSize: '12px', m: 0, mt: 1}}>{addressPart2}</Text>
          <Box
            sx={{
              visibility: dateAvailable ? 'visible' : 'hidden',
              mt: 2,
              mb: 4,
            }}>
            <Tag
              label={`Available: ${dateAvailable}`}
              variant="outlined"
              color="primary"
              disableIcon
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}>
            <PropertyAttributes
              noOfBedrooms={bedrooms}
              noOfBathrooms={bathrooms}
              noOfCarparks={parkingSpaces}
              iconSize="28px"
              sx={{fontSize: '14px'}}
            />
            {rentAmount && (
              <IconLabel
                color="tertiary"
                icon={<MonetizationOnIcon color="tertiary" />}
                text={rentAmount}
                sx={{ml: 'auto'}}
              />
            )}
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}

PropertyCard.propTypes = {
  photo: PropTypes.string,
  addressPart1: PropTypes.string,
  addressPart2: PropTypes.string,
  rentAmount: PropTypes.string,
  dateAvailable: PropTypes.string,
  bedrooms: PropTypes.number,
  bathrooms: PropTypes.number,
  parkingSpaces: PropTypes.number,
  onView: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(null)]),
};

export default PropertyCard;
